import { render, staticRenderFns } from "./manifest.vue?vue&type=template&id=33e6239b&scoped=true&"
import script from "./manifest.vue?vue&type=script&lang=ts&"
export * from "./manifest.vue?vue&type=script&lang=ts&"
import style0 from "./manifest.vue?vue&type=style&index=0&id=33e6239b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e6239b",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CImage: require('@chakra-ui/vue').CImage})
